import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { keyBy } from 'lodash';
import { SortAndFilterService } from 'src/modules/shared/services/sort-and-filter.service';

@Component({
  selector: 'app-sort-modal',
  templateUrl: './sort-modal.component.html',
  styleUrls: ['./sort-modal.component.scss'],
})
export class SortModalComponent implements OnInit {

  @Input() data?: {
    key?: string; // Key to identify the sort option, if needed,
    defaultSelectedSortOption?: string; // Default selected option
    sortOptions?: Array<{
      label: string;
      value: string;
      sortOrder: "asc" | "desc";
    }>;
    title?: string; // Optional title for the modal
  }

  sortOptions : Array<{
    label: string;
    value: string;
    sortOrder: "asc" | "desc";
  }>;

  selectedSortOption: string;

  title: string = "shifts";

  constructor(private modalCtrl: ModalController, private sortAndFilterService: SortAndFilterService) {}

  ngOnInit() {
    
    // Check if there is a sort option already selected
    this.sortOptions = this.data?.sortOptions || [];
    this.selectedSortOption = this.data?.defaultSelectedSortOption || "shiftStartTime";
    this.title = this.data?.title || "shifts";
    let sortOption = this.sortAndFilterService.getSort(this.data.key);
    if(sortOption && sortOption.sortColumn) {
      this.selectedSortOption = this.sortOptions.find(option => option.value === sortOption.sortColumn).value;
    }else{
      this.selectedSortOption = this.data.defaultSelectedSortOption
    }
  }

  dismissModal() {

    this.modalCtrl.dismiss(false)

  }

  resetSort() {
    this.sortAndFilterService.clearSort(this.data.key)
    this.modalCtrl.dismiss({
      
    });
  }

  applySort() {
    let sortOption = this.sortOptions.find(option => option.value === this.selectedSortOption);

    if(!sortOption) {
      return;
    }

    this.sortAndFilterService.setSort(this.data.key, {
      sortColumn: sortOption.value,
      sortOrder: sortOption.sortOrder
    })
    this.modalCtrl.dismiss();
  }

  handleCheckboxSelect(value: string){
    this.selectedSortOption = value
  }
}